import merge from 'deepmerge';

function isHexColorCode(code) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(code);
}
var overwriteMerge = function (destinationArray, sourceArray, options) { return sourceArray; };
function mergeObjects(objA, objB) {
    return merge(objA, objB, { arrayMerge: overwriteMerge });
}

var ARLinkButton = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
    'ar-link-button',
    _vm.active && 'active',
    _vm.disabled && 'disabled',
    _vm.hasUnderlineOnHover && 'has-underline-on-hover',
    _vm.colorClassName ],style:({
    color: _vm.isCustomColor ? _vm.color : null,
    textDecoration: _vm.hasUnderline ? 'underline' : null,
  }),attrs:{"ar-widget-id":"ar-link-button","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-link-button"},on:{"click":_vm.handleButtonClick}},[_c('div',{staticClass:"icon-text-section"},[(_vm.iconName)?_c('ar-icon',_vm._b({},'ar-icon',_vm.decoratedIconProps,false)):_vm._e(),_vm._v(" "),_c('ar-text',_vm._b({staticClass:"text",attrs:{"text":_vm.text}},'ar-text',_vm.decoratedTextProps,false))],1),_vm._v(" "),(_vm.hasArrow)?_c('ar-icon',{staticClass:"arrow-icon",style:({
      marginLeft: _vm.textArrowDistance,
    }),attrs:{"name":"arrow","rotate":_vm.active ? 180 : 0}}):_vm._e()],1)},
staticRenderFns: [],
  name: 'ARLinkButton',
  props: {
    arWidgetMeta: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'purple',
      validator: (value) => {
        return ['purple', 'black', 'grey'].indexOf(value) > -1 || isHexColorCode(value);
      },
    },
    active: {
      type: Boolean,
      default: false,
    },
    iconTextDistance: {
      type: String,
      default: '7px',
    },
    textArrowDistance: {
      type: String,
      default: '5px',
    },
    text: {
      type: String,
      default: null,
    },
    textProps: {
      type: Object,
      default: () => ({
        weight: 'normal',
        size: 'xs',
      }),
    },
    iconName: {
      type: String,
      default: null,
    },
    iconProps: {
      type: Object,
      default: () => ({}),
      validator: (val) => {
        if (val.style) {
          console.error('ar-link-button:', ' Sorry, we are not allowing "style" in "iconProps", will allow it needed');
          return false;
        }
        if (val.class) {
          console.error('ar-link-button:', ' Sorry, we are not allowing "class" in "iconProps", will allow it if needed');
          return false;
        }
        return true;
      }
    },
    hasArrow: {
      type: Boolean,
      default: false,
    },
    hasUnderline: {
      type: Boolean,
      default: true,
    },
    hasUnderlineOnHover: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedArWidgetMeta() {
      return [
        `text=${this.text};`,
      ].join('');
    },
    isCustomColor() {
      return isHexColorCode(this.color);
    },
    colorClassName() {
      return this.isCustomColor ? 'custom' : this.color;
    },
    decoratedTextProps() {
      return mergeObjects({
        weight: 'normal',
        size: 'xs',
      }, this.textProps);
    },
    decoratedIconProps() {
      const defaultProps = {
        class: 'icon',
        height: '16px',
        name: this.iconName,
        rotate: this.active ? 180 : 0,
        style: {
          marginRight: this.iconTextDistance,
        },
      };

      // If parent wants to customize the size, we shall remove default size.
      if (this.iconProps.height || this.iconProps.width) {
        defaultProps.height = null;
        defaultProps.width = null;
      }

      return mergeObjects(
        defaultProps,
        this.iconProps,
      );
    },
  },
  methods: {
    handleButtonClick(e) {
      e.stopPropagation();
      if (this.disabled) {
        return;
      }
      this.$emit('click');
    },
  },
};

export default ARLinkButton;
